import { FunctionComponent, h } from 'preact'
import { useState } from 'preact/hooks'

import { Button } from 'components/ui'
import { ButtonAlign, CtaField as CtaFieldType } from 'scripts/type'
import FieldWrapper from '../components/FieldWrapper'
import { FieldCommonProps } from '../type'

import classes from './cta.scss'
import cls from 'classnames'

enum ChoiceValue {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

const CtaField: FunctionComponent<FieldCommonProps> = (props) => {
  const { field, onFieldSubmit } = props
  const { choices, primaryButtonLink, secondaryButtonLink, buttonAlign } = field as CtaFieldType
  const [disabled, setDisabled] = useState(false)

  const handleClick = (value: string) => {
    setDisabled(true)
    onFieldSubmit?.({
      value: [value],
    })
    if (value === ChoiceValue.PRIMARY) {
      primaryButtonLink && window.open(primaryButtonLink, '_blank')
    } else {
      secondaryButtonLink && window.open(secondaryButtonLink, '_blank')
    }
  }

  return (
    <FieldWrapper
      {...props}
      className={classes.wrapper}
      handlerProps={{ visible: false }}
      headerClass={classes.header}
      titleClass={classes.title}
      descriptionClass={classes.description}
    >
      <div className={cls(classes.ctaField, classes[buttonAlign ?? ButtonAlign.START])}>
        {choices.map((choice) => (
          <Button
            disabled={disabled}
            key={choice.value}
            fullWidth={false}
            width="50%"
            className={classes.button}
            onClick={() => handleClick(choice.value)}
            type={choice.value as any}
          >
            {choice.label}
          </Button>
        ))}
      </div>
    </FieldWrapper>
  )
}

export default CtaField
